/* TWRD card quick add — Black & White only.
   Replaces the theme quick shop popup with an inline size row inside the card image. */
(function () {
  'use strict';

  /* Included by every section that renders TWRD cards. One set of listeners. */
  if (window.__twrdCardQuickInit) return;
  window.__twrdCardQuickInit = true;

  var OPEN_CARD = null;

  function parseData(card) {
    if (card.twrdQsData !== undefined) return card.twrdQsData;
    var node = card.querySelector('[data-twrd-qs-json]');
    var data = null;
    if (node) {
      try {
        data = JSON.parse(node.textContent);
      } catch (err) {
        data = null;
        if (window.console) console.warn('twrd-card-quick: bad variant JSON', err);
      }
    }
    card.twrdQsData = data;
    return data;
  }

  function variantById(data, id) {
    if (!id) return null;
    var wanted = String(id);
    for (var i = 0; i < data.variants.length; i += 1) {
      if (String(data.variants[i].id) === wanted) return data.variants[i];
    }
    return null;
  }

  function optionValue(variant, position) {
    if (!variant || !position) return null;
    return variant.o[position - 1] || null;
  }

  /* Colour + style come from the swatch the shopper picked, else the card default. */
  function referenceVariant(card, data) {
    var swatch = card.querySelector('product-card-variant-swatch.is-active[variant-id]');
    var fromSwatch = swatch ? variantById(data, swatch.getAttribute('variant-id')) : null;
    return fromSwatch || variantById(data, data.defaultId) || data.variants[0] || null;
  }

  function matchesFor(data, reference, size) {
    var colour = optionValue(reference, data.colorPos);
    var style = optionValue(reference, data.stylePos);
    var pool = data.variants.filter(function (variant) {
      if (data.sizePos && optionValue(variant, data.sizePos) !== size) return false;
      if (data.colorPos && colour && optionValue(variant, data.colorPos) !== colour) return false;
      return true;
    });
    var sameStyle = pool.filter(function (variant) {
      return !style || optionValue(variant, data.stylePos) === style;
    });
    var ordered = sameStyle.length ? sameStyle : pool;
    var available = ordered.filter(function (variant) {
      return variant.a;
    });
    return { pick: available[0] || ordered[0] || null, available: available.length > 0 };
  }

  function buildRow(card, data) {
    var host = card.querySelector('[data-twrd-qs-sizes]');
    if (!host) return;
    var reference = referenceVariant(card, data);
    host.textContent = '';

    data.sizes.forEach(function (size) {
      var match = matchesFor(data, reference, size);
      var button = document.createElement('button');
      button.type = 'button';
      button.className = 'twrd-qs__size';
      button.textContent = size;
      if (!match.pick || !match.available) {
        button.disabled = true;
        button.setAttribute('aria-disabled', 'true');
        button.setAttribute('aria-label', 'Size ' + size + ' sold out');
      } else {
        button.setAttribute('data-variant-id', String(match.pick.id));
        button.setAttribute('aria-label', 'Add size ' + size + ' to cart');
      }
      host.appendChild(button);
    });
  }

  function closePanel(card) {
    if (!card) return;
    var panel = card.querySelector('[data-twrd-qs]');
    if (!panel) return;
    panel.classList.remove('is-open');
    panel.setAttribute('aria-hidden', 'true');
    if (OPEN_CARD === card) OPEN_CARD = null;
  }

  function openPanel(card) {
    var data = parseData(card);
    var panel = card.querySelector('[data-twrd-qs]');
    if (!data || !panel || !data.sizes.length) return;
    if (OPEN_CARD && OPEN_CARD !== card) closePanel(OPEN_CARD);
    buildRow(card, data);
    panel.classList.add('is-open');
    panel.setAttribute('aria-hidden', 'false');
    OPEN_CARD = card;
  }

  function addToCart(card, button) {
    var variantId = button.getAttribute('data-variant-id');
    var form = card.querySelector('.twrd-qs-form form');
    var input = form ? form.querySelector('input[name="id"]') : null;
    if (!variantId || !form || !input) return;
    input.value = variantId;
    button.classList.add('is-busy');
    /* Reuse the theme product-form: it calls the cart store and opens the cart drawer. */
    if (typeof form.requestSubmit === 'function') {
      form.requestSubmit();
    } else {
      form.dispatchEvent(new Event('submit', { bubbles: true, cancelable: true }));
    }
    window.setTimeout(function () {
      button.classList.remove('is-busy');
      closePanel(card);
    }, 700);
  }

  document.addEventListener(
    'click',
    function (event) {
      var grid = event.target.closest ? event.target.closest('.twrd-cards') : null;

      if (!grid) {
        if (OPEN_CARD) closePanel(OPEN_CARD);
        return;
      }

      var trigger = event.target.closest('[quickshop-trigger], [data-trigger-quick-shop]');
      if (trigger) {
        var triggerCard = trigger.closest('product-card');
        if (triggerCard) {
          event.preventDefault();
          event.stopPropagation();
          if (OPEN_CARD === triggerCard) {
            closePanel(triggerCard);
          } else {
            openPanel(triggerCard);
          }
          return;
        }
      }

      if (event.target.closest('[data-twrd-qs-close]')) {
        event.preventDefault();
        event.stopPropagation();
        closePanel(event.target.closest('product-card'));
        return;
      }

      var size = event.target.closest('.twrd-qs__size');
      if (size) {
        event.preventDefault();
        event.stopPropagation();
        if (!size.disabled) addToCart(size.closest('product-card'), size);
        return;
      }

      if (OPEN_CARD && !event.target.closest('[data-twrd-qs]')) closePanel(OPEN_CARD);
    },
    true
  );

  document.addEventListener('keydown', function (event) {
    if (event.key === 'Escape' && OPEN_CARD) closePanel(OPEN_CARD);
  });

  /* A colour change rebuilds the open row so sizes match the new colour. */
  document.addEventListener('click', function (event) {
    var swatch = event.target.closest ? event.target.closest('product-card-variant-swatch') : null;
    if (!swatch) return;
    var card = swatch.closest('product-card');
    if (!card || OPEN_CARD !== card) return;
    window.setTimeout(function () {
      var data = parseData(card);
      if (data) buildRow(card, data);
    }, 0);
  });

  /* ------------------------------------------------------------------ */
  /* Hover image follows the chosen colour.
     The theme swaps only the primary image on a swatch click, so the hover
     image kept the first colour. snippets/twrd-card-hover-map.liquid writes
     colour -> hover media into data-twrd-hover. Same srcset widths as the
     card renders today, see the image snippet call in product-card.liquid. */

  var HOVER_WIDTHS = [120, 240, 360, 480, 620, 740, 900, 1080];
  var HOVER_DEFAULT_WIDTH = 300;

  function hoverMap(card) {
    if (card.twrdHoverMap !== undefined) return card.twrdHoverMap;
    var raw = card.getAttribute('data-twrd-hover');
    var map = null;
    if (raw) {
      try {
        map = JSON.parse(raw);
      } catch (err) {
        map = null;
        if (window.console) console.warn('twrd-card-quick: bad hover JSON', err);
      }
    }
    card.twrdHoverMap = map;
    return map;
  }

  /* null = natural ratio, the image keeps its own aspect. */
  function containerRatio(card) {
    var raw = card.getAttribute('image-container-ratio') || 'natural';
    if (raw === 'natural') return null;
    var parts = raw.split(':');
    var w = parseFloat(parts[0]);
    var h = parseFloat(parts[1]);
    if (!w || !h) return null;
    return h / w;
  }

  function hoverImageAttributes(card, entry) {
    var image = card.querySelector('img.product-card__img-hover');
    if (!image || !entry || !entry.src || !entry.w || !entry.h) return null;

    var ratio = containerRatio(card);
    var uncropped = ratio === null || card.hasAttribute('image-fit');
    var aspect = entry.w / entry.h;
    var masterWidth = entry.w;
    var masterHeight = entry.h;

    if (!uncropped) {
      masterHeight = Math.round(masterWidth * ratio);
      if (masterHeight > entry.h) {
        masterHeight = entry.h;
        masterWidth = Math.round(masterHeight / ratio);
      }
    }

    var join = entry.src.indexOf('?') === -1 ? '?' : '&';
    var srcset = HOVER_WIDTHS.reduce(function (acc, width) {
      var height = Math.round(uncropped ? width / aspect : width * ratio);
      if (width > masterWidth || height > masterHeight) return acc;
      var crop = uncropped ? '' : '&height=' + height + '&crop=center';
      return acc + entry.src + join + 'width=' + width + crop + ' ' + width + 'w ' + height + 'h, ';
    }, '');

    var master = uncropped
      ? entry.src + join + 'width=' + masterWidth
      : entry.src + join + 'width=' + masterWidth + '&height=' + masterHeight + '&crop=center';

    /* src holds the 300px default, same as the image snippet renders. */
    var defaultWidth = Math.min(HOVER_DEFAULT_WIDTH, masterWidth);
    var defaultHeight = Math.round(uncropped ? defaultWidth / aspect : defaultWidth * ratio);
    if (defaultHeight > masterHeight) {
      defaultHeight = masterHeight;
      defaultWidth = Math.round(uncropped ? defaultHeight * aspect : defaultHeight / ratio);
    }
    var crop = uncropped ? '' : '&height=' + defaultHeight + '&crop=center';

    return {
      image: image,
      src: entry.src + join + 'width=' + defaultWidth + crop,
      srcset: srcset + master + ' ' + masterWidth + 'w ' + masterHeight + 'h',
      sizes: image.getAttribute('sizes') || '',
      width: String(defaultWidth),
      height: String(defaultHeight),
      alt: entry.alt || ''
    };
  }

  function applyHoverImage(card, entry) {
    var attrs = hoverImageAttributes(card, entry);
    if (!attrs) return;

    var requestId = (card.twrdHoverRequestId || 0) + 1;
    card.twrdHoverRequestId = requestId;
    if (card.twrdHoverPreload) {
      card.twrdHoverPreload.onload = null;
      card.twrdHoverPreload.onerror = null;
    }

    var image = attrs.image;
    if (card.twrdHoverVisibility === undefined) {
      card.twrdHoverVisibility = image.style.visibility;
    }
    image.style.visibility = 'hidden';

    function writeAttributes() {
      image.setAttribute('src', attrs.src);
      image.setAttribute('srcset', attrs.srcset);
      image.setAttribute('width', attrs.width);
      image.setAttribute('height', attrs.height);
      image.setAttribute('alt', attrs.alt);
    }

    /* Update the DOM in the click turn. Visibility stays off until the browser
       has the same responsive candidate ready, so hover cannot reveal the old bitmap. */
    writeAttributes();

    var preload = new Image();
    card.twrdHoverPreload = preload;
    preload.onload = function () {
      if (card.twrdHoverRequestId !== requestId) return;
      writeAttributes();
      function reveal() {
        if (card.twrdHoverRequestId !== requestId) return;
        image.style.visibility = card.twrdHoverVisibility;
        card.twrdHoverPreload = null;
      }
      if (typeof preload.decode === 'function') {
        preload.decode().catch(function () {}).then(reveal);
      } else {
        reveal();
      }
    };
    preload.onerror = function () {
      if (card.twrdHoverRequestId !== requestId) return;
      card.twrdHoverPreload = null;
    };
    if (attrs.sizes) preload.sizes = attrs.sizes;
    preload.srcset = attrs.srcset;
    preload.src = attrs.src;
  }

  document.addEventListener(
    'click',
    function (event) {
      var swatch = event.target.closest
        ? event.target.closest('product-card-variant-swatch[data-twrd-colour]')
        : null;
      if (!swatch) return;
      var card = swatch.closest('product-card');
      if (!card) return;
      var map = hoverMap(card);
      if (!map) return;
      applyHoverImage(card, map[swatch.getAttribute('data-twrd-colour')]);
    },
    true
  );
})();

/* TWRD 2026-10-07: drop the reserved second title line in a card row when no
   title in that row actually wraps. See .twrd-titles-1 in twrd-card-quick.css. */
(function twrdTitleLines() {
  if (window.__twrdTitleLines) return;
  window.__twrdTitleLines = true;

  function lines(title) {
    var inner = title.querySelector('product-card-title') || title;
    var rects = inner.getClientRects();
    var tops = {};
    for (var i = 0; i < rects.length; i++) {
      if (rects[i].width > 0) tops[Math.round(rects[i].top)] = true;
    }
    return Object.keys(tops).length;
  }

  function run() {
    document.querySelectorAll('.twrd-cards').forEach(function (row) {
      var titles = row.querySelectorAll('.product-card__title');
      if (!titles.length) return;
      var single = true;
      for (var i = 0; i < titles.length; i++) {
        if (titles[i].offsetParent !== null && lines(titles[i]) > 1) { single = false; break; }
      }
      row.classList.toggle('twrd-titles-1', single);
    });
  }

  var t;
  function soon() { clearTimeout(t); t = setTimeout(run, 120); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run); else run();
  window.addEventListener('load', run);
  window.addEventListener('resize', soon);
  if (document.fonts && document.fonts.ready) document.fonts.ready.then(run);
  document.addEventListener('shopify:section:load', soon);
})();
